__turbopack_context__.v({
  "revise-section-button": "fvOqJq_revise-section-button",
  "revision-composer-status": "fvOqJq_revision-composer-status",
  "revision-draft": "fvOqJq_revision-draft",
  "revision-draft-label": "fvOqJq_revision-draft-label",
  "revision-failed": "fvOqJq_revision-failed",
  "revision-saved": "fvOqJq_revision-saved",
  "revision-status": "fvOqJq_revision-status",
  "revision-target": "fvOqJq_revision-target",
  "section-revision": "fvOqJq_section-revision",
});
